var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"expande-horizontal sheet-container pt-2",attrs:{"dark":_vm.$theme.dark,"light":_vm.$theme.light}},[_c('v-flex',{staticClass:"pr-1",attrs:{"xs12":""}},[_c('Filters',{attrs:{"filter":_vm.filter}}),_c('List',{attrs:{"filtereds":_vm.filtereds}}),(_vm.filtereds.length === 0)?_c('EmptyList'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }